import { network } from 'services/network';

export const getShowPredictionLikelihoodForProject = (params: QueryParams) => {
    const url = `api/bo/getActivityPredictionPercentageViewStatus?projectId=${params.projectId}`;
    return network.post(url).then((response) => response.data);
};

export interface QueryParams {
    projectId: number;
}

export type QueryResponse = boolean;
